import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IOneUserByEmailPayload {
    email: any
    sagaCB?: {
        onSuccess: any
    }
}

const initialState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const oneByEmailSlice = createSlice({
    name: 'hub/user/one-by-email',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IOneUserByEmailPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload.data
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const oneByEmailActions = oneByEmailSlice.actions
export default oneByEmailSlice.reducer
